import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/houses', { params });
  },
  create(data) {
    return axios.post('/v1/houses', data);
  },
  detail(id) {
    return axios.get(`/v1/houses/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/houses/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/houses/${id}`);
  }
};
